import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getGlobalSearch } from '../../services/Search';
import { SearchResponse } from '../../types/Search';

function useGlobalSearch(
  fleetId: string,
  query: string,
  input: string,
): UseQueryResult<SearchResponse> {
  return useQuery(
    ['global-search', fleetId, query],
    async (): Promise<SearchResponse> => getGlobalSearch(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      enabled: !!input,
    },
  );
}

export default useGlobalSearch;
